export const EXPERIMENT_KEYS = {
  EXPERIMENT_KEY_HERO_953_01: '953_01_HERO',
  EXPERIMENT_KEY_DATE_953_01: '953_01_DATE',
  SEE_ROOMS_AND_PLANS_953_02: '953_02_url_change',
} as const;
